/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createInvoiceDtoFromDiscriminatorValue, serializeCreateManyInvoicesRequest, serializeInvoiceDto, type CreateManyInvoicesRequest, type ErrorResponse, type InternalErrorResponse, type InvoiceDto } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/invoices/bulk
 */
export interface BulkRequestBuilder extends BaseRequestBuilder<BulkRequestBuilder> {
    /**
     * Imports a batch of invoices in one call, following the same rules as the single-invoice endpoint: each starts in Draft unless imported totals are supplied, and an invoice number that already exists updates that invoice rather than creating a duplicate. Failures are per-record, not per-batch — an invoice that cannot be built (for example one that arrives with no line items) is skipped and the rest are still created, so compare the returned list against what you sent. The call only fails outright when the list is empty or every record was skipped. A sales rep may be supplied by rep number alone; numbers are matched against the organization's reps for the whole batch, and one that matches nothing is stored as unassigned.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<InvoiceDto[]>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: CreateManyInvoicesRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<InvoiceDto[] | undefined>;
    /**
     * Imports a batch of invoices in one call, following the same rules as the single-invoice endpoint: each starts in Draft unless imported totals are supplied, and an invoice number that already exists updates that invoice rather than creating a duplicate. Failures are per-record, not per-batch — an invoice that cannot be built (for example one that arrives with no line items) is skipped and the rest are still created, so compare the returned list against what you sent. The call only fails outright when the list is empty or every record was skipped. A sales rep may be supplied by rep number alone; numbers are matched against the organization's reps for the whole batch, and one that matches nothing is stored as unassigned.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: CreateManyInvoicesRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const BulkRequestBuilderUriTemplate = "{+baseurl}/api/invoices/bulk";
/**
 * Metadata for all the requests in the request builder.
 */
export const BulkRequestBuilderRequestsMetadata: RequestsMetadata = {
    put: {
        uriTemplate: BulkRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createInvoiceDtoFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateManyInvoicesRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
